<template>
  <section id="home" class="section hero">
    <div class="section-container hero-grid reveal">
      <div class="hero-copy">
        <span class="section-label">Studio Produk Digital</span>
        <h1 class="hero-title">Teknologi Inovatif untuk Dampak Nyata</h1>
        <p class="hero-description">
          Solusi teknologi efisien untuk kemajuan kerja dan pembelajaran. Kami
          membantu organisasi membangun sistem digital yang modern, cepat, dan
          mudah digunakan.
        </p>

        <div class="hero-actions">
          <a href="#services" class="btn btn-primary">Lihat Layanan</a>
          <a href="#portofolio" class="btn btn-ghost">Lihat Proyek</a>
        </div>
      </div>

      <div class="hero-visual card" aria-hidden="true">
        <svg class="hero-art" viewBox="0 0 640 460" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="hero-bg" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#0b428d" />
              <stop offset="100%" stop-color="#0f67d7" />
            </linearGradient>
            <linearGradient id="panel-accent" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#ff8383" />
              <stop offset="100%" stop-color="#ff5f5f" />
            </linearGradient>
            <linearGradient id="line-chart" x1="0" y1="1" x2="1" y2="0">
              <stop offset="0%" stop-color="#66a7ff" />
              <stop offset="100%" stop-color="#1d57a8" />
            </linearGradient>
          </defs>

          <rect x="0" y="0" width="640" height="460" rx="26" fill="url(#hero-bg)" />

          <circle cx="102" cy="72" r="72" fill="#ffffff" opacity="0.08" class="float-a" />
          <circle cx="584" cy="410" r="84" fill="#ffffff" opacity="0.08" class="float-b" />

          <g class="float-a" style="animation-delay: 0.2s">
            <rect x="76" y="82" width="488" height="302" rx="22" fill="#f8fbff" />
            <rect x="76" y="82" width="488" height="42" rx="22" fill="#e5efff" />
            <circle cx="104" cy="104" r="7" fill="#ff8383" />
            <circle cx="126" cy="104" r="7" fill="#ffc063" />
            <circle cx="148" cy="104" r="7" fill="#59c28b" />

            <rect x="110" y="154" width="126" height="11" rx="6" fill="#0f4da2" />
            <rect x="110" y="178" width="164" height="8" rx="4" fill="#a7bede" />
            <rect x="110" y="206" width="188" height="62" rx="12" fill="#eaf2ff" />

            <rect x="126" y="227" width="20" height="24" rx="6" fill="#6f9ad7" />
            <rect x="158" y="215" width="20" height="36" rx="6" fill="#5a87c8" />
            <rect x="190" y="202" width="20" height="49" rx="6" fill="#3d6fb8" />
            <rect x="222" y="222" width="20" height="29" rx="6" fill="#87addf" />
            <rect x="254" y="194" width="20" height="57" rx="6" fill="#2f5fa7" />

            <rect x="110" y="286" width="188" height="78" rx="12" fill="#0d4da4" />
            <rect x="132" y="310" width="94" height="10" rx="5" fill="#ffffff" opacity="0.9" />
            <rect x="132" y="332" width="130" height="8" rx="4" fill="#ffffff" opacity="0.6" />

            <rect x="320" y="154" width="208" height="210" rx="14" fill="#ffffff" />
            <rect x="344" y="180" width="102" height="11" rx="5" fill="#0f4da2" />
            <rect x="344" y="203" width="154" height="8" rx="4" fill="#b0c5e3" />

            <polyline
              points="344,280 374,258 404,270 434,232 464,242 494,208"
              fill="none"
              stroke="url(#line-chart)"
              stroke-width="7"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle cx="374" cy="258" r="6" fill="#0f4da2" />
            <circle cx="404" cy="270" r="6" fill="#0f4da2" />
            <circle cx="434" cy="232" r="6" fill="#0f4da2" />
            <circle cx="464" cy="242" r="6" fill="#0f4da2" />
            <circle cx="494" cy="208" r="6" fill="#0f4da2" />

            <rect x="344" y="304" width="62" height="34" rx="9" fill="#e9f2ff" />
            <rect x="414" y="304" width="62" height="34" rx="9" fill="#e9f2ff" />
            <rect x="484" y="304" width="22" height="34" rx="9" fill="url(#panel-accent)" />
          </g>

          <g class="float-b" style="animation-delay: 0.4s">
            <rect x="442" y="56" width="144" height="84" rx="14" fill="#ffffff" opacity="0.96" />
            <text x="460" y="90" fill="#1b3f7c" font-size="12" font-weight="600" font-family="Sora, sans-serif">
              Efisiensi Tim
            </text>
            <text x="460" y="122" fill="#0d4da4" font-size="30" font-weight="700" font-family="Sora, sans-serif">
              95%
            </text>
          </g>
        </svg>

        <div class="hero-badge badge-top">
          <strong>2019</strong>
          <span>Berdiri</span>
        </div>
        <div class="hero-badge badge-bottom">
          <strong>50+</strong>
          <span>Proyek selesai</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
};
</script>

<style scoped>
.hero {
  padding-top: calc(var(--header-height) + 34px);
}

.hero-grid {
  display: grid;
  grid-template-columns: 1.02fr 0.98fr;
  gap: 34px;
  align-items: center;
}

.hero-title {
  margin-top: 10px;
  font-size: clamp(2.1rem, 5.4vw, 4rem);
  line-height: 1.08;
  color: var(--text);
}

.hero-description {
  margin-top: 18px;
  max-width: 560px;
  font-size: clamp(1rem, 1.55vw, 1.14rem);
}

.hero-actions {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.hero-visual {
  position: relative;
  overflow: hidden;
  border-radius: var(--radius-l);
  min-height: 470px;
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow: var(--shadow-soft);
}

.hero-art {
  width: 100%;
  height: 100%;
  display: block;
}

.hero-badge {
  position: absolute;
  z-index: 2;
  display: grid;
  gap: 4px;
  min-width: 136px;
  padding: 14px 16px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(13, 77, 164, 0.18);
  box-shadow: 0 10px 22px rgba(9, 39, 82, 0.16);
}

.hero-badge strong {
  font-family: "Sora", sans-serif;
  font-size: 1.25rem;
  color: var(--primary);
}

.hero-badge span {
  font-size: 0.84rem;
  font-weight: 600;
  color: #304266;
}

.badge-top {
  top: 18px;
  left: 18px;
}

.badge-bottom {
  right: 18px;
  bottom: 18px;
}

.float-a,
.float-b {
  animation: floatY 6.5s ease-in-out infinite;
}

@keyframes floatY {
  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-6px);
  }
}

@media (max-width: 980px) {
  .hero-grid {
    grid-template-columns: 1fr;
  }

  .hero-visual {
    min-height: 340px;
  }
}

@media (max-width: 640px) {
  .hero {
    padding-top: calc(var(--header-height) + 16px);
  }

  .hero-actions {
    width: 100%;
  }

  .hero-actions .btn {
    flex: 1;
    min-width: 132px;
  }

  .hero-badge {
    min-width: 120px;
    padding: 10px 12px;
  }

  .hero-badge strong {
    font-size: 1.05rem;
  }
}
</style>
